export default {
  props:{
    is_mark_work_pro:{ type: Boolean, default: true }, //помечать работы pro аккаунтов
    class_masonry: { type: String, default: 'masonry-gallery__grid masonry-grid' },
    // 'masonry-gallery__grid masonry-grid' - четыре колонки
    // 'masonry-gallery__grid masonry-grid masonry-gallery__grid-col-3' - три колонки
  },

  data() {
    return {
      T:null,
      maxWorksOnPage: 20,//WorksPaginationMix
      is_subdomain: $('#app-wrapper').attr('is_subdomain'),
      is_pro_page: $('#app-wrapper').attr('is_pro_page'),
    }
  },

  created: function () {
    this.$store.dispatch('getUserId').then(() => {})
    this.$store.dispatch('getWorks')
  },

  updated() {
    clearTimeout(this.T);

    this.$nextTick(()=>{
      this.T=setTimeout( ()=>{
        window.global.destroy_masonry('.masonry');

        window.global.init_masonry('.masonry', {
          itemSelector: '.item',
          /*columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer',*/
          percentPosition: true,
        }, function(){
          //отключаем фиксированную высоту блока с работами
          $('#id_main_works_list').css('height', '');
          //чтобы пагинатор перерисовать
          window.dispatchEvent(new Event('resize'));
        });

      }, 150 );
    });
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksListMix.js
// module id = null
// module chunks = 